import { createTheme } from '@material-ui/core/styles';
import { alpha } from '@material-ui/core/styles/colorManipulator';
const white = "#fff";
const grey = "#757575";

const primaryDefault = "#304393";
const secondaryDefault = "#0E67BA";

export default class Theme {

  static get(primaryColor, secondaryColor) {
    const primary = primaryColor || primaryDefault;
    const secondary = secondaryColor || secondaryDefault;

    const theme = createTheme({
      palette: {
        primary: {
          main: primary,
          contrastText: white,
        },
        secondary: {
          main: secondary,
          contrastText: white,
        }
      },
      typography: {
        fontFamily: "\"museo-sans\", \"Helvetica\", \"Arial\", sans-serif",
      },
      breakpoints: {
        values: {
          xs: 0,
          sm: 576,
          md: 768,
          lg: 992,
          xl: 1200,
        },
      },
      overrides: {
        MuiButton: {
          containedPrimary: {
            '&:hover': {
              color: white,
            },
            '&:focus': {
              boxShadow: `0 0 5px 0px ${primary}`,
              outline: 'none'
            }
          },
          containedSecondary: {
            '&:focus': {
              outline: 'none'
            }
          },
          outlined: {
            padding: '15px',
            boxShadow: '0px 2px 4px 0px lightgrey',
            textTransform: 'none',
          },
          outlinedPrimary: {
            '&:hover': {
              color: primary,
              backgroundColor: alpha(primary, .05),
              border: `1px solid ${alpha(primary, .2)}`,
              outline: 'none',
            },
            '&:focus': {
              backgroundColor: alpha(primary, .15),
              border: `1px solid ${primary}`,
              outline: 'none'
            }
          },
          text: {
            '&:focus': {
              outline: 'none',
              boxShadow: 'none',
            },
            textTransform: 'none',
          },
          textPrimary: {
            fontWeight: 'bold',
            letterSpacing: '1px',
            '&:hover': {
              backgroundColor: alpha(primary, .05),
              color: primary,
            },
            '&:focus': {
              backgroundColor: alpha(primary, .15),
              outline: 'none'
            }
          },
        },
        MuiTextField: {
          root: {
            backgroundColor: white,
            borderRadius: '4px',
          }
        },
        MuiOutlinedInput: {
          notchedOutline: {
            borderColor: grey,
          }
        },
        MuiLinearProgress: {
          root: {
            height: '.6rem',
            borderRadius: '10px',
          },
          bar: {
            borderRadius: '10px',
          }
        },
        MuiCardContent: {
          root: {
            padding: '15px',
          }
        },
        MuiTouchRipple: {
          child: {
            backgroundColor: primary
          }
        }
      }
    });
    return theme;
  }
}


// WEBPACK FOOTER //
// ./src/components/Theme/Theme.js